module.exports = __webpack_public_path__ + "img/JLTP_content_N1.3f2619d3.svg";